"use client";

import { useEffect } from "react";

import { installHydrationErrorReporter } from "@/lib/hydration-error-reporter";

// Module-evaluation install. This runs when the root layout's client chunk is
// evaluated — before `hydrateRoot` — which is the only way to observe a
// hydration mismatch reported during the FIRST commit, when no useEffect has
// run yet. `installHydrationErrorReporter` is a no-op without a `window`, so
// the server render of this client component is unaffected.
installHydrationErrorReporter();

/**
 * Gives React's recoverable hydration errors an identity in the owned
 * `js_error` stream. Renders nothing; the work is the window listener and the
 * bounded mutation witness in `@/lib/hydration-error-reporter`.
 *
 * Deliberately mounted OUTSIDE `SensitiveTelemetryGate`: the gate would delay
 * (and on payment routes remove) the component, but the beacon itself is gated
 * — `reportJsError` calls `isBrowserTelemetrySuppressed()` before any send, so
 * a sensitive payment route still emits nothing.
 */
export default function HydrationErrorReporter() {
  // Belt-and-braces for any renderer that evaluates modules lazily.
  useEffect(() => {
    installHydrationErrorReporter();
  }, []);

  return null;
}
